<template>
  <div :key="refresh_key">
    <!-- *** Naziv tvrtke **** -->
    <form-input
      :invalid="invalid_elements.tvrtka"
      :label="$t('forms.person.prav_pers.name_lbl')"
      id="tvrtka"
      ref="nazivTvrtke"
      required="required"
      :base="pravna.tvrtka"
    ></form-input>
    <!-- OIB -->
    <form-input :label="$t('forms.person.phys_pers.oib')" id="oib" ref="OIB" :base="pravna.oib"></form-input>

     <!-- *** Email *** -->
    <form-input-multiple :base="pravna.email_list" ref="email" :name="'email'" :label="$t('forms.person.phys_pers.email_lbl')" :placeholder="$t('forms.person.phys_pers.email_plh')" />
    <!-- *** Broj telefona *** -->
    <form-input-multiple :base="pravna.tel_br_list" ref="telefon" :name="'telefon'" :label="$t('forms.person.phys_pers.tel_lbl')" :placeholder="$t('forms.person.phys_pers.tel_plh')" />
    <!-- *** Web stranica *** -->
    <form-input-multiple :base="pravna.web_list" ref="stranica" :name="'stranica'" :label="$t('forms.person.phys_pers.web_lbl')" :placeholder="$t('forms.person.phys_pers.web_plh')" />
    
    
  <div class="form-divider"></div>
    <!-- *** Adresa **** -->
    <adresa-element ref="adresaElement" :base="pravna.adrese_list" />
    <div class="form-divider"></div>
    <IzvjesceFileUpload ref="sudskiRegIzvod" :label="$t('forms.person.prav_pers.izvod_lbl')" :file="edit_izvod" :oib="pravna.oib" @clearActiveFile="clearActiveFile"/>
    <div class="form-divider"></div>
    <!-- *** INDUSTRIJA **** -->
    <form-drop-down
      :label="$t('forms.person.phys_pers.indust_lbl')"
      id="industrija"
      ref="industrija"
      :dropImport="industrija"
      :base="pravna.industrija_id.ID"
    ></form-drop-down>

    <!-- *** Godišnji prihod **** -->
    <form-input
      :label="$t('forms.person.phys_pers.prihod_lbl')"
      id="godisnji-prihod"
      ref="godisnjiPrihod"
      :base="pravna.god_prihod"
    ></form-input>
    <!-- *** Tip izvora **** -->
    <form-drop-down
      :label="$t('forms.person.phys_pers.tip_izvora')"
      id="tip-izvor"
      ref="tipIzvor"
      :dropImport="tipovi_izvora"
      :base="pravna.id_tip_izvora.ID"
    ></form-drop-down>
    <form-autocomplete-single
      :invalid="invalid_elements.izvor"
      :style="pravna.id_tip_izvora.ID < 3 ? 'display:flex' : 'display:none'"
      :name="'imeIzvora'"
      :placeholder="pravna.id_tip_izvora.ID == 1 ? $t('forms.person.phys_pers.izvor1') : $t('forms.person.phys_pers.izvor2')"
      :type="'Izvor'"
      :id="'izvor'"
      ref="imeIzvora"
      :items="pravna.id_tip_izvora.ID == 1 ? fizicke : pravne"
    ></form-autocomplete-single>
    <form-autocomplete 
      :style="pravna.id_tip_izvora.ID == 3 ? 'display:flex' : 'display:none'" 
      :label="$t('forms.person.phys_pers.members_lbl')" 
      type="clanovi_tima" 
      id="clanovi-tima-eventi" 
      ref="clanoviTima"
      placeholder="Odaberite članove tima" :items="clanovi">
    </form-autocomplete>
    <!-- *** Izvor izvan sustava **** -->
    <form-input
      :invalid="invalid_elements.custom_ime_izvora"
      :style="pravna.id_tip_izvora.ID == 4 ? 'display:flex' : 'display:none'"
      :label="$t('forms.person.phys_pers.custom_lbl')"
      id="custom-izvor"
      ref="customIzvor"
      :base="pravna.custom_ime_izvora"
    ></form-input>
    <!-- *** Drugi kontakt ****
    <form-input
      label="Drugi kontakt"
      id="drugi-kontakt"
      ref="drugiKontakt"
    ></form-input> -->
    <!-- *** Radno vrijeme **** -->
    <form-input
      :label="$t('forms.person.phys_pers.radno_lbl')"
      id="radno-vrijeme"
      ref="radnoVrijeme"
    ></form-input>
    <!-- *** OPIS **** -->
    <form-textarea :label="$t('forms.person.phys_pers.opis_lbl')" id="opis" ref="opis" :base="pravna.opis"></form-textarea>
  </div>
</template>

<script>
import formInput from "@/components/formElements/formInput.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import adresaElement from "@/components/formElements/adresaElement.vue";
import formAutocompleteSingle from '@/components/formElements/formAutocompleteSingle.vue'
import formInputMultiple from '@/components/formElements/formInputMultiple.vue'
import IzvjesceFileUpload from '@/components/personComponents/IzvjesceFileUpload.vue'
import osoba from "@/apiCallers/promise_handler_db/osobe_pr";

export default {
  data() {
    return {
      refresh_key: 1,
      pravna: {
        tvrtka: "",
        oib: "",
        email_list: [],
        tel_br_list: [],
        adrese_list: [],
        web_list: [],
        multiple_izvori: [],
        industrija_id:{ID:1},
        god_prihod: "",
        id_tip_izvora:{ID:5},
        izvor_osoba: "",
        custom_ime_izvora: "",
        radno_vrijeme: "",
        opis: "",
        sudski_reg_izvod: null,
      },
      edit_izvod:null,
    };
  },
  methods: {
    clearActiveFile(){
      this.edit_izvod = null;
    }
  },
  async created() {
    let route_name = this.$router.history.current.name;
    if (route_name === "LegalPersonEdit") {
     osoba.getPravna(this.$router.history.current.params.oib)
        .then(async (resp) => {
               console.log(resp.data)

          console.log("OSOBA:")
          const pravno_tijelo =resp.data;
          console.log(pravno_tijelo)
          this.$refs.nazivTvrtke.$data.value = pravno_tijelo.ime == null ? '':pravno_tijelo.ime;
          this.$refs.OIB.$data.value = pravno_tijelo.oib == null ? '':pravno_tijelo.oib
          this.$refs.industrija.$data.ID = pravno_tijelo.industrija_id.id;
          this.$refs.godisnjiPrihod.$data.value = pravno_tijelo.god_prihod == null ? '':pravno_tijelo.god_prihod;
          this.$refs.tipIzvor.$data.ID = pravno_tijelo.id_tip_izvora.id_tip_izvora;
          this.$refs.adresaElement.$data.lista_adresa = pravno_tijelo.adresa == null ? [] : pravno_tijelo.adresa;

          this.$refs.email.$data.values = pravno_tijelo.email_list
          this.$refs.telefon.$data.values = pravno_tijelo.tel_br_list;
          this.$refs.stranica.$data.values = pravno_tijelo.web_list;
          this.$refs.customIzvor.$data.value = pravno_tijelo.custom_ime_izvora == null ? '':pravno_tijelo.custom_ime_izvora;
          this.$refs.radnoVrijeme.$data.value = pravno_tijelo.radno_vrijeme == null ? '': pravno_tijelo.radno_vrijeme;
          this.$refs.opis.$data.value = pravno_tijelo.opis == null ? '' : pravno_tijelo.opis;
          this.edit_izvod = pravno_tijelo.izvod_sud_reg && pravno_tijelo.izvod_sud_reg.id == undefined ? null : pravno_tijelo.izvod_sud_reg;
          //odvjetnik_odvjetnikTopravna_osoba_src_team_uid
          switch (pravno_tijelo.id_tip_izvora.id_tip_izvora) {
            case 1:
              this.$refs.imeIzvora.$data.results_final.uid =pravno_tijelo.izvor_fizicka.uid;
              this.$refs.imeIzvora.$data.results_final.name = pravno_tijelo.izvor_fizicka.ime +' '+pravno_tijelo.izvor_fizicka.prezime
              break;
            case 2:
              this.$refs.imeIzvora.$data.results_final.uid =pravno_tijelo.izvor_pravna.uid;
              this.$refs.imeIzvora.$data.results_final.name = pravno_tijelo.izvor_pravna.ime
              break;
            case 3:
              pravno_tijelo.izvor_clan_tima.forEach(odvj => {
                this.$refs.clanoviTima.$data.results_final.push({
                  'UID': odvj.uid,
                  'is_fiz': true,
                  'name': odvj.ime + ' ' + odvj.prezime,
                  'status_ID': 1
                });
                setTimeout(() => {
                  this.$emit('update:clanovi', this.clanovi.filter((fiz) => fiz.link != odvj.uid));
                }, 100);
              });
              break;
            default:
              break;
          }
          this.$emit("finished");
          
        });
    }
  },
  mounted() {
    this.$refs.tipIzvor.$data.ID = 5;
    this.pravna.tvrtka = this.$refs.nazivTvrtke.$data;
    this.pravna.oib = this.$refs.OIB.$data;

    this.pravna.industrija_id = this.$refs.industrija.$data;
    this.pravna.god_prihod = this.$refs.godisnjiPrihod.$data;
    this.pravna.id_tip_izvora = this.$refs.tipIzvor.$data;
    this.pravna.adrese_list = this.$refs.adresaElement.$data;
    this.pravna.izvor_osoba = this.$refs.imeIzvora.$data;
    this.pravna.multiple_izvori = this.$refs.clanoviTima.$data;
    this.pravna.custom_ime_izvora = this.$refs.customIzvor.$data;
    this.pravna.email_list = this.$refs.email.$data;
    this.pravna.tel_br_list = this.$refs.telefon.$data;
    this.pravna.web_list = this.$refs.stranica.$data;

    this.pravna.radno_vrijeme = this.$refs.radnoVrijeme.$data;
    this.pravna.opis = this.$refs.opis.$data;
    this.pravna.sudski_reg_izvod = this.$refs.sudskiRegIzvod.$data;
  },
  props: ["industrija", "tipovi_izvora","fizicke", "clanovi","pravne","invalid_elements"],
  components: {
    "form-input": formInput,
    "form-textarea": formTextarea,
    "form-drop-down": formDropDown,
    "form-autocomplete": formAutocomplete,
    "adresa-element":adresaElement,
    "form-autocomplete-single":formAutocompleteSingle,
    "form-input-multiple":formInputMultiple,
    IzvjesceFileUpload
  },
};
</script>
